import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const GarrisonInfoService = {
    getGarrison: async (id) => axios.get(API_URL + `/reports/garrison_info/${id}/data`).then(({ data }) => data).catch((err) => { throw err }),

    getDispatch: (id) => `${BASENAME}${API_DESPACHO_WEB}/dispatch/form/${id}`,

    getOccurrence: (id) => `${BASENAME}bo/${String(id).replace(/\//g, "-")}`,
}

export default GarrisonInfoService;